<template>
  <v-layout class="select-metrics-view" fluid column justify-center fill-height>
    <Tabs :settings="tabSettings"></Tabs>
    <MetricSelection @change="save" v-bind="formData"></MetricSelection>

  </v-layout>
</template>

<script>
import MetricSelection from '@/components/survey/MetricSelection'
import Tabs from '@/components/Tabs'
import routes from '@/route_names'
export default {
  name: 'SelectMetricsView',
  components: {
    MetricSelection,
    Tabs
  },
  data: function() {
    return {
      formData: {
        nps: this.$store.getters['user/currentCampaign'].nps_enabled,
        csat: this.$store.getters['user/currentCampaign'].csat_enabled,
        ces: this.$store.getters['user/currentCampaign'].ces_enabled
      },
    }
  },
  computed: {
    tabSettings: function() {
      const tabs = []
      
        tabs.push({
          id: routes.SURVEY_METRICS,
          label: 'Survey'
        })
      return {
        preselected: null,
        tabs: tabs
      }
    }
  },
  methods: {
    save(data) {
      data.campaignId = this.$router.currentRoute.params.campaignId
      this.$store
        .dispatch('campaign/updateMetricStatus', data)
        .then(function(campaign) {
          console.log(campaign)
        })
    }
  }
}
</script>

<style lang="stylus">
.select-metrics-view {
    padding 0
    padding-left: 25px
}
</style>
